import Textlink from './Textlink';
import { types, iconTypes, helper } from './types';
import variants from './variants';

export {
  types, iconTypes, helper, variants,
};

export default Textlink;
